import React from "react";

export default function Banner() {
  return (
    <div className="container-fluid b25">
      <p className="text-center b25 text-light pb-5 pt-3 m-0 h6 d-md-none font-weight-bolder">
        Explore and purchase your perfect cosmetics
      </p>
      <h3 className="text-center b25 text-light py-4 m-0 d-none d-md-block font-weight-bolder">
        Explore and purchase your perfect cosmetics
      </h3>
    </div>
  );
}
